import styled from 'styled-components';
import { Text14Light, Text16Light } from '../../../components/utils/Text/Text.styles';
import { Button } from '../../../components/utils/Button/Button';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 76rem;
  padding: 2.4rem 0;

  @media only screen and (max-width: 760px) {
    padding: 1.6rem 1.2rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2.4rem 0;

  @media only screen and (max-width: 700px) {
    margin: 1.6rem 0;
  }
`;

export const DescriptionText = styled(Text16Light)`
  line-height: 2.9rem;
  letter-spacing: -0.408px;
`;

export const CardsContainer = styled.div`
  display: flex;
  gap: 1.6rem;
  flex-wrap: wrap;

  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

export const StyledButton = styled(Button)`
  width: 35rem;
  margin-top: 1.6rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const NoteText = styled(Text14Light)`
  width: 22rem;
  text-align: center;
  opacity: 0.5;
  margin-inline: auto;
  margin-top: 2.4rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;
